import '../../../../App.css'
import { useFormulario } from './useFormulario.js';
import Tooltip from '@mui/material/Tooltip';
import { Alert } from '../../../messages/Alert'

const Formulario = ({ onSave, onCancel, comision, render }) => {
    const { updateDescripcion, updateCodigoInterno, handleSubmit, handleChangeInput, alert,
        descripcion, codigoInterno } = useFormulario(onSave, onCancel, comision, render);

    return (
        <form onSubmit={handleSubmit}>
            {alert && (
                <Alert
                    severity={alert.severity}
                    title={alert.title}
                    isForm={true}
                >
                    {alert.message}
                </Alert>
            )}
            <div className="fila-form">
                <div className="columna-form">
                    <label className={render !== "View" ? "required" : ""}>
                        Código Interno:
                    </label>
                    <Tooltip title="Código Interno">
                        <input className='input-form' id="input-codigo-interno" type="text" value={codigoInterno} maxLength="100" placeholder='Código Interno' onChange={(e) => { handleChangeInput(e); updateCodigoInterno(e.target.value) }} disabled={render === 'View' ? true : null} />
                    </Tooltip>
                </div>

                <div className="columna-form">
                    <label className={render !== "View" ? "required" : ""}>
                        Descripción:
                    </label>
                    <Tooltip title="Descripción">
                        <input className='input-form' id="input-descripcion" type="text" value={descripcion} maxLength="300" placeholder='Descripción' onChange={(e) => { handleChangeInput(e); updateDescripcion(e.target.value) }} disabled={render === 'View' ? true : null} />
                    </Tooltip>
                </div>
            </div>
            <div className="fila-form">
                <div className="button-form">
                    {render !== 'View' && (
                        <Tooltip title="Aceptar">
                            <button id="btn-accion" className="action-button">Aceptar</button>
                        </Tooltip>
                    )}
                    <Tooltip title="Cancelar">
                        <button id="btn-cancelar" className="action-button" onClick={onCancel}>Cancelar</button>
                    </Tooltip>
                </div>
            </div>
        </form>
    );
};
export { Formulario };